import { localize, pluralize } from 'i18n/localize.ts';
import { cn } from 'utils/cn';
import { UPCOMING_EXPIRING_DAYS } from 'utils/constants';

const $t = localize();

export function OfferRemainingDays({ days }: { days: number | null }) {
	if (days === null) return <></>;

	const text =
		days <= 0
			? $t.offer.expiringToday
			: `${pluralize(days, $t.offer.remaining, true)}\u00A0${pluralize(days, $t.offer.days, true)}`;

	return (
		<>
			,<span>&nbsp;</span>
			<span class={cn(days !== null && days <= UPCOMING_EXPIRING_DAYS && 'text-red font-bold')}>{text}</span>
		</>
	);
}
